<template>
  <vs-popup
    title="You have unsaved changes"
    color="primary"
    :active="active"
    class="unsaved-changes-popup"
    @close="$emit('close')"
  >
    <p>
      You have unsaved changes. Your changes will be lost if you discard
      them.
    </p>
    <div class="flex flex-wrap justify-end mt-6">
      <vs-button
        class="mr-3 mb-3"
        color="primary"
        @click="$emit('save')"
      >
        {{ primaryLabel }}
      </vs-button>
      <vs-button
        class="mb-3 unsaved-changes-popup__discard-btn"
        type="border"
        color="dark"
        @click="$emit('discard')"
      >
        {{ secondaryLabel }}
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'UnsavedChangesPopup',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    primaryLabel: {
      type: String,
      default: 'Save and leave',
    },
    secondaryLabel: {
      type: String,
      default: 'Discard and leave',
    },
  },
}
</script>
